import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ZoneForm from "@components/forms/ZoneForm";

const ZoneAddEdit = () => {
  const params = useParams()
  const { id: zoneId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!zoneId ? 'Agregar' : 'Editar'} Zona de Client`}
      backUrl="/user/client-zones"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "zoneForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ZoneForm
        formId="zoneForm"
        id={zoneId}
        saveRedirectUrl="/user/client-zones"
      ></ZoneForm>

    </PageContainer>
  );
}

export default ZoneAddEdit;
